module.exports = __webpack_public_path__ + "static/media/040-man-11.33dc4287.svg";